import axios from "axios";
import { useEffect, useLayoutEffect, useReducer, useRef, useState } from "react";
import AudioVideoSelector from "./AudioVideoSelector";
import CallLayout from "./CallLayout";
import Join from "./Join";
import MeetingEnded from "./MeetingEnded";
import Navbar from "./Navbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CheckIcon } from "@heroicons/react/outline";
import { ActiveSpeaker } from "./ActiveSpeaker";
import { Newsletter } from "./Newsletter";

let API_LOCATION = "";
let DEADSIMPLESCREENSHARING_MODE = false;
if (window.location.hostname === "localhost" || window.location.hostname.indexOf("tsocket") > -1) {
  API_LOCATION = "http://localhost:4000";
  // API_LOCATION = "https://your-app-name.metered.live";
  window.appName = "your-app-name";
  window.roomName = "debug";
} else {
  API_LOCATION = "";
}

if (window.appName === "screensharing") {
  DEADSIMPLESCREENSHARING_MODE = true;
}

/* eslint-disable */
const meeting = new Metered.Meeting();
/* eslint-enable */

function reducer(state, action) {
  const stream = action.stream;
  const tiles = Object.assign({}, state);
  switch (action.action) {
    case "addTile": {
      if (!tiles[stream.participantSessionId]) {
        tiles[stream.participantSessionId] = stream.participant
          ? {
              participant: stream.participant,
              streams: []
            }
          : {
              participant: {},
              streams: []
            };
      }
      // Updating the participant properties
      if (tiles[stream.participantSessionId]) {
        if (stream.participant) {
          tiles[stream.participantSessionId].participant = stream.participant;
        }
      }

      tiles[stream.participantSessionId].streams.push(stream);
      return tiles;
    }
    case "removeTile": {
      if (
        stream &&
        stream.participantSessionId &&
        tiles[stream.participantSessionId] &&
        tiles[stream.participantSessionId].streams &&
        tiles[stream.participantSessionId].streams.length > 0
      ) {
        for (let i = 0; i < tiles[stream.participantSessionId].streams.length; i++) {
          if (tiles[stream.participantSessionId].streams[i].streamId === stream.streamId) {
            tiles[stream.participantSessionId].streams.splice(i, 1);
          }
        }
        if (tiles[stream.participantSessionId].streams.length === 0) {
          delete tiles[stream.participantSessionId];
        }
      }
      return tiles;
    }
    default: {
      throw new Error();
    }
  }
}

function sendEventToIFrame(type, message) {
  try {
    message = Object.assign({}, message, { track: undefined });
    window.parent.postMessage({ type, message }, "*");
  } catch (ex) {
    console.log("Error occurred window.postMessage", ex);
  }
}

function App() {
  const autoJoin = window.autoJoin || false;
  const showInviteBox = window.showInviteBox || false;
  const roomName = window.roomName;
  const appName = window.appName;
  const ownBranding = window.ownBranding ? (window.ownBranding === "true" ? true : false) : false;
  const brandName = window.brandName ? window.brandName : "";
  const defaultMeetingEndedMessage = window.defaultMeetingEndedMessage
    ? window.defaultMeetingEndedMessage
    : "";
  const [chatRoomURL, setChatRoomURL] = useState("");

  const [meetingJoined, setMeetingJoined] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const userInfoRef = useRef(false);
  userInfoRef.current = userInfo;

  const [accessToken, setAccessToken] = useState(window.accessToken || "");
  const [meetingSessionId, setMeetingSessionId] = useState(null);
  const [meetingEnded, setMeetingEnded] = useState(true);
  const [meetingLeft, setMeetingLeft] = useState(false);
  const [cameraMuted, setCameraMuted] = useState(window.joinVideoOn === false ? true : false);
  const [micMuted, setMicMuted] = useState(window.joinAudioOn === false ? true : false);
  const [screenShared, setScreenShared] = useState(false);
  const [handRaised, setHandRaised] = useState(false);
  const [chatVisible, setChatVisible] = useState(false);
  const [onlineUsersVisible, setOnlineUsersVisible] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const [settingsVisible, setSettingsVisible] = useState(false);

  const [selectedMic, setSelectedMic] = useState(null);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [username, setUsername] = useState(window.username || "");
  const [localMediaStream, setLocalMediaStream] = useState(null);
  const [videoTiles, videoTilesDispatcher] = useReducer(reducer, {});

  const [onlineUsers, setOnlineUsers] = useState([]);
  const onlineUsersRef = useRef([]);
  onlineUsersRef.current = onlineUsers;

  const [meetingAccessRequests, setMeetingAccessRequests] = useState([]);
  const meetingAccessRequestsRef = useRef([]);
  meetingAccessRequestsRef.current = meetingAccessRequests;

  const cameraAccessBlocked = false;
  const microphoneAccessBlocked = false;
  const chatMode = "none";

  const [disableAudio, setDisableAudio] = useState(
    window.enableMicrophone === false ? true : false
  );
  const [disableVideo, setDisableVideo] = useState(window.enableCamera === false ? true : false);
  const [disableScreenSharing, setDisableScreenSharing] = useState(
    window.enableScreenSharing === false ? true : false
  );
  const [disabledChat, setDisabledChat] = useState(window.enableChat === false ? true : false);

  const [joining, setJoining] = useState(false);
  const [activeSpeakerId, setActiveSpeakerId] = useState(null);
  const [activeSpeakerName, setActiveSpeakerName] = useState(null);

  /**
   * Handing iFrame Events
   */
  useEffect(() => {
    async function EventHandler(event) {
      if (event.data.type === "joinMeeting") {
        let message = event.data.message;
        if (message.name) {
          setUsername(message.name);
        }

        if (message.accessToken) {
          setAccessToken(message.accessToken);
        }

        handleJoinMeetingBtnClick({
          passedName: message.name,
          passedAccessToken: message.accessToken
        });
      }

      if (event.data.type === "leaveMeeting") {
        handleEndCallButtonClicked();
      }

      if (event.data.type === "openChat") {
        if (!disabledChat) {
          setChatVisible(true);
        }
      }

      if (event.data.type === "closeChat") {
        setChatVisible(false);
      }

      if (event.data.type === "startCamera") {
        if (!disableVideo && cameraMuted) {
          try {
            await meeting.startVideo();
            setCameraMuted(false);
          } catch (ex) {
            setCameraMuted(true);
            toast("Unable to start Camera");
          }
        }
      }

      if (event.data.type === "stopCamera") {
        if (!cameraMuted) {
          try {
            await meeting.stopVideo();
            setCameraMuted(true);
          } catch (ex) {}
        }
      }

      if (event.data.type === "startAudio") {
        if (!disableAudio && micMuted) {
          try {
            await meeting.startAudio();
            setMicMuted(false);
          } catch (ex) {
            setMicMuted(true);
            toast("Unable to start Microphone");
          }
        }
      }

      if (event.data.type === "startScreenShare") {
        if (!screenShared) {
          try {
            const stream = await meeting.startScreenShare();
            if (localMediaStream) {
              localMediaStream.getTracks().forEach(track => {
                track.stop();
              });
            }
            setLocalMediaStream(stream);
            setScreenShared(true);
          } catch (ex) {
            toast("Unable to share screen");
          }
        }
      }

      if (event.data.type === "stopScreenShare") {
        if (screenShared) {
          try {
            await meeting.stopVideo();
            if (localMediaStream) {
              localMediaStream.getTracks().forEach(track => {
                track.stop();
              });
            }
            setScreenShared(false);
          } catch (ex) {}
        }
      }
    }

    window.addEventListener("message", EventHandler);

    return () => {
      window.removeEventListener("message", EventHandler);
    };
  });

  /**
   * Creating one time useEffect similar to mounted
   */
  useLayoutEffect(() => {
    if (autoJoin) {
      handleJoinMeetingBtnClick();
    }

    meeting.on("remoteTrackStarted", function(track) {
      console.log("Remote track started", track);

      sendEventToIFrame("remoteTrackStarted", track);

      videoTilesDispatcher({ action: "addTile", stream: track });
    });

    meeting.on("remoteTrackStopped", function(track) {
      console.log("Remote track stopped", track);

      sendEventToIFrame("remoteTrackStopped", track);

      videoTilesDispatcher({ action: "removeTile", stream: track });
    });

    meeting.on("onlineParticipants", onlineParticipants => {
      console.log("onlineParticipants", onlineParticipants);

      sendEventToIFrame("onlineParticipants", onlineParticipants);

      setOnlineUsers([...onlineParticipants]);
    });

    meeting.on("participantLeft", function(participantLeft) {
      sendEventToIFrame("participantLeft", participantLeft);
    });

    meeting.on("participantJoined", function(participantInfo) {
      sendEventToIFrame("participantJoined", participantInfo);
    });

    meeting.on("localTrackStarted", localTrackItem => {
      console.log("localTrackStarted", localTrackItem);

      if (localTrackItem.type === "video") {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(localTrackItem.track);
        setLocalMediaStream(mediaStream);
        if (window.ownerOnlyBroadcast) {
          videoTilesDispatcher({
            action: "addTile",
            stream: {
              participantSessionId: userInfoRef.current._id,
              participant: userInfoRef.current,
              type: localTrackItem.type,
              streamId: "localStream",
              track: localTrackItem.track
            }
          });
        }
      }
    });

    meeting.on("localTrackUpdated", localTrackItem => {
      sendEventToIFrame("localTrackUpdated", localTrackItem);

      if (localTrackItem.type === "video") {
        if (window.ownerOnlyBroadcast) {
          videoTilesDispatcher({
            action: "removeTile",
            stream: {
              participantSessionId: userInfoRef.current._id,
              participant: userInfoRef.current,
              type: "video",
              streamId: "localStream"
            }
          });
        }

        const mediaStream = new MediaStream();
        mediaStream.addTrack(localTrackItem.track);
        setLocalMediaStream(mediaStream);
        if (window.ownerOnlyBroadcast) {
          videoTilesDispatcher({
            action: "addTile",
            stream: {
              participantSessionId: userInfoRef.current._id,
              participant: userInfoRef.current,
              type: localTrackItem.type,
              streamId: "localStream",
              track: localTrackItem.track
            }
          });
        }
      }
    });

    meeting.on("localTrackStopped", localTrackItem => {
      sendEventToIFrame("localTrackStopped", localTrackItem);

      if (localTrackItem.type === "video") {
        setLocalMediaStream(null);
        if (window.ownerOnlyBroadcast) {
          videoTilesDispatcher({
            action: "removeTile",
            stream: {
              participantSessionId: userInfoRef.current._id,
              participant: userInfoRef.current,
              type: "video",
              streamId: "localStream"
            }
          });
        }
      }
    });

    meeting.on("disableParticipantAudio", async () => {
      setDisableAudio(true);
      setMicMuted(true);
      await meeting.stopAudio();
    });

    meeting.on("disableParticipantVideo", async () => {
      setDisableVideo(true);
      setCameraMuted(true);
      await meeting.stopVideo();
    });

    meeting.on("enableParticipantAudio", async () => {
      setDisableAudio(false);
    });

    meeting.on("enableParticipantVideo", async () => {
      setDisableVideo(false);
    });

    meeting.on("participantPermissionUpdated", info => {
      const users = onlineUsersRef.current;

      for (let i = 0; i < users.length; i++) {
        if (users[i]._id === info.participantSessionId) {
          users[i].disableAudio = info.disableAudio;
          users[i].disableVideo = info.disableVideo;
          users[i].disableScreenSharing = info.disableScreenSharing;
          users[i].disableChat = info.disableChat;
        }
      }
      if (users.length > 0) {
        setOnlineUsers([...users]);
      }
    });

    meeting.on("participantSharingStateUpdated", info => {
      sendEventToIFrame("participantSharingStateUpdated", info);

      const users = onlineUsersRef.current;
      console.log("participantSharingStateUpdated", info, users);
      for (let i = 0; i < users.length; i++) {
        if (users[i]._id === info.participantSessionId) {
          // users[i].disableAudio = info.disableAudio;
          // users[i].disableVideo = info.disableVideo;
          // users[i].disableScreenSharing = info.disableScreenSharing;
          // users[i].disableChat = info.disableChat;
          users[i].sharingScreen = info.sharingScreen;
          users[i].sharingAudio = info.sharingAudio;
          users[i].sharingVideo = info.sharingVideo;
        }
      }
      if (users.length > 0) {
        setOnlineUsers([...users]);
      }
    });

    meeting.on("meetingLeft", function() {
      sendEventToIFrame("meetingLeft", {});

      setMeetingLeft(true);
    });
  }, []);

  useLayoutEffect(() => {
    async function loadRequestToJoin() {
      if (userInfo.isAdmin) {
        try {
          const { data } = await axios.get(
            `${API_LOCATION}/api/v1/meetingsession/${meetingSessionId}/meetingaccessrequests?accessToken=${accessToken}`
          );
          console.log("Pending access requests", data);
          setMeetingAccessRequests(data);
        } catch (ex) {
          console.log("Error occurred when trying to load pending access requests", ex);
        }
      }
    }

    loadRequestToJoin();
  }, [onlineUsersVisible, userInfo]);

  useLayoutEffect(() => {
    meeting.on("newMeetingAccessRequest", function(message) {
      console.log("newMeetingAccessRequest in app", message);
      const requests = meetingAccessRequestsRef.current;
      requests.push(message);
      setMeetingAccessRequests([...requests]);

      const MeetingRequest = ({ handleAcceptRequestToJoin, username, requestId }) => {
        return (
          <div>
            <p className="mb-4">User: {username} is requesting to Join the Meeting</p>

            <button
              onClick={() => {
                handleAcceptRequestToJoin(requestId);
              }}
              type="button"
              className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <CheckIcon className="w-4 mr-2" />
              Accept
            </button>
          </div>
        );
      };

      toast(
        <MeetingRequest
          handleAcceptRequestToJoin={handleAcceptRequestToJoin}
          requestId={message._id}
          username={message.name}
        />
      );
    });

    return () => {
      meeting.removeListener("newMeetingAccessRequest");
    };
  });

  let activeSpeakerTimeoutRef = useRef(null);
  useLayoutEffect(() => {
    meeting.on("activeSpeaker", speakerInfo => {
      setActiveSpeakerId(speakerInfo.participantSessionId);
      setActiveSpeakerName(speakerInfo.name);

      sendEventToIFrame("activeSpeaker", speakerInfo);

      console.log("Active speaker info", speakerInfo);
    });

    if (activeSpeakerTimeoutRef.current) {
      clearTimeout(activeSpeakerTimeoutRef.current);
    }

    activeSpeakerTimeoutRef.current = setTimeout(() => {
      setActiveSpeakerId("");
      setActiveSpeakerName("");
    }, 1000);

    return () => {
      meeting.removeListener("activeSpeaker");
    };
  });

  /**
   * Effect to handle the local media stream
   */
  // useLayoutEffect(() => {
  //   async function getLocalMediaStream() {
  //     try {
  //       const stream = await meeting.getLocalVideoStream();
  //       setLocalMediaStream(stream);
  //       setCameraMuted(false);
  //     } catch (ex) {
  //       console.log("Error occurred obtaining media stream", ex);
  //       setCameraMuted(true);
  //     }
  //   }

  //   if (!localMediaStream && !cameraMuted) {
  //     getLocalMediaStream();
  //   }

  //   return () => {
  //     if (localMediaStream) {
  //       console.log("Stopping the streams");
  //       localMediaStream.getTracks().forEach(track => {
  //         track.stop();
  //       });
  //       setLocalMediaStream(null);
  //     }
  //   };
  // }, [localMediaStream, cameraMuted]);

  useLayoutEffect(() => {
    if (localMediaStream) {
      setCameraMuted(false);
    }
  }, [localMediaStream]);

  function shouldSidebarBeVisible() {
    if (chatVisible && chatMode === "none") {
      return true;
    }

    if (onlineUsersVisible) {
      return true;
    }

    if (settingsVisible) {
      return true;
    }

    return false;
  }

  function handleMicButtonClicked() {
    setMicMuted(!micMuted);
    if (meetingJoined) {
      if (micMuted) {
        meeting.startAudio();
      } else {
        meeting.stopAudio();
      }
    }
  }

  async function handleCameraButtonClicked() {
    setCameraMuted(!cameraMuted);

    if (screenShared) return;

    if (meetingJoined) {
      if (cameraMuted) {
        try {
          await meeting.startVideo();
        } catch (ex) {
          setCameraMuted(true);
          return;
        }
      } else {
        await meeting.stopVideo();
      }
    }
  }

  async function handleCameraChanged(deviceId) {
    if (deviceId) {
      await meeting.chooseVideoInputDevice(deviceId);
      setSelectedCamera(deviceId);
    }
  }

  async function handleMicChanged(deviceId) {
    if (deviceId) {
      await meeting.chooseAudioInputDevice(deviceId);
      setSelectedMic(deviceId);
    }
  }

  async function handleSpeakerChanged(deviceId) {
    debugger;
    if (deviceId) {
      await meeting.chooseAudioOutputDevice(deviceId);
      setSelectedSpeaker(deviceId);
    }
  }

  async function handleJoinMeetingBtnClick(options) {
    setJoining(true);

    let joinParams = {
      roomURL: appName + ".metered.live/" + roomName // window.location.hostname + window.location.pathname //  "screensharing.metered.live/xhntqtzvkh"
    };

    if (username.length > 100) {
      joinParams.accessToken = username;
      joinParams.accessToken = joinParams.accessToken.trim();
    } else {
      joinParams.name = username;
      joinParams.name = joinParams.name.trim();
    }

    if (accessToken) {
      joinParams.accessToken = accessToken;
    }

    if (options && options.passedName) {
      joinParams.name = options.passedName;
    }

    if (options && options.passedAccessToken) {
      joinParams.accessToken = options.passedAccessToken;
    }

    let meetingResponse;
    try {
      meetingResponse = await meeting.join(joinParams);
    } catch (errorResponse) {
      if (errorResponse && errorResponse.requestMeetingAccessEnabled) {
        // Sending request to join;
        try {
          const requestToJoinResponse = await meeting.requestMeetingAccess(joinParams);
          console.log("Request to Join Response", requestToJoinResponse);
          joinParams.accessToken = requestToJoinResponse.accessToken;
          meetingResponse = await meeting.join(joinParams);
          setJoining(false);
        } catch (ex) {
          toast(ex.message);
          setJoining(false);
          return;
        }
      } else {
        toast(errorResponse.message);
        setJoining(false);
        return;
      }
    }

    setChatRoomURL(meeting._getChatRoomURL());

    try {
      sendEventToIFrame("meetingJoined", meetingResponse);
    } catch (ex) {}

    setMeetingJoined(true);
    setJoining(false);
    setUserInfo(meetingResponse.participantInfo);
    setAccessToken(meetingResponse.accessToken);
    setMeetingSessionId(meetingResponse.meetingSessionId);
    if (meetingResponse.participantInfo.isAdmin) {
      setIsAdmin(true);
    }

    if (!meetingResponse.participantInfo.isAdmin && window.ownerOnlyBroadcast) {
      setCameraMuted(true);
      setMicMuted(true);
      setDisableAudio(meetingResponse.participantInfo.disableAudio);
      setDisableVideo(meetingResponse.participantInfo.disableVideo);
      setDisableScreenSharing(meetingResponse.participantInfo.disableScreenSharing);
      setDisabledChat(meetingResponse.participantInfo.disableChat);
      // Returning here because code below is to enable camera and microphone,
      // which we don't want in case of ownerOnlyBroadcast.
      return;
    }

    if (!cameraMuted && !disableVideo) {
      try {
        await meeting.startVideo();
      } catch (ex) {
        setCameraMuted(true);
        toast("Unable to start Camera");
      }
    }
    if (!micMuted && !disableAudio) {
      try {
        await meeting.startAudio();
      } catch (ex) {
        setMicMuted(true);
        toast("Unable to start Mic");
      }
    }
  }

  function handleChatButtonClicked() {
    setChatVisible(!chatVisible);
  }

  async function handleScreenShareButtonClicked() {
    setScreenShared(!screenShared);
    if (!screenShared) {
      const stream = await meeting.startScreenShare();
      console.log(stream);
      localMediaStream.getTracks().forEach(track => {
        track.stop();
      });
      setLocalMediaStream(stream);
    } else {
      await meeting.stopVideo();
      if (!cameraMuted) {
        await meeting.startVideo();
      }
    }
  }

  useLayoutEffect(() => {
    console.log("Local Stream updated");
  }, [localMediaStream]);

  function handleHandRaisedButtonClicked() {
    setHandRaised(!handRaised);
  }

  function handleOnlineUsersButtonClicked() {
    setOnlineUsersVisible(!onlineUsersVisible);
  }

  async function handleEndCallButtonClicked() {
    console.log("End call button clicked");
    await meeting.leaveMeeting();
    setMeetingLeft(true);
  }

  function handleSettingsButtonClicked() {
    setSettingsVisible(!settingsVisible);
  }

  async function handleBanUser(userId) {
    console.log("handle ban user called", userId);
  }

  async function handleMuteUserVideo(userId, userVideoDisabled) {
    console.log("mute user video called", userId);

    if (userVideoDisabled) {
      // Enabling video
      try {
        const { data } = await axios.post(
          `${API_LOCATION}/api/v1/meetingsession/${meetingSessionId}/enable/video/participant?accessToken=${accessToken}`,
          {
            participantSessionId: userId
          }
        );
        console.log("Video mute response", data);
      } catch (ex) {
        console.log("Error occurred when trying to enable user video");
      }
    } else {
      // Disabling video
      try {
        const { data } = await axios.post(
          `${API_LOCATION}/api/v1/meetingsession/${meetingSessionId}/disable/video/participant?accessToken=${accessToken}`,
          {
            participantSessionId: userId
          }
        );
        console.log("Video mute response", data);
      } catch (ex) {
        console.log("Error occurred when trying to disable user video");
      }
    }
  }

  async function handleMuteUserAudio(userId, userAudioDisabled) {
    console.log("mute user audio called", userId);

    if (userAudioDisabled) {
      // Enabling Audio
      try {
        const { data } = await axios.post(
          `${API_LOCATION}/api/v1/meetingsession/${meetingSessionId}/enable/audio/participant?accessToken=${accessToken}`,
          {
            participantSessionId: userId
          }
        );
        console.log("Audio mute response", data);
      } catch (ex) {
        console.log("Error occurred when trying to enable user audio");
      }
    } else {
      // Disabling Audio
      try {
        const { data } = await axios.post(
          `${API_LOCATION}/api/v1/meetingsession/${meetingSessionId}/disable/audio/participant?accessToken=${accessToken}`,
          {
            participantSessionId: userId
          }
        );
        console.log("Audio mute response", data);
      } catch (ex) {
        console.log("Error occurred when trying to disable user audio");
      }
    }
  }

  async function handleEjectUser(userId) {
    console.log("eject user called", userId);

    try {
      const { data } = await axios.post(
        `${API_LOCATION}/api/v1/meetingsession/${meetingSessionId}/eject/participant?accessToken=${accessToken}`,
        {
          participantSessionId: userId
        }
      );
      console.log("Eject User Success", data);
    } catch (ex) {
      console.log("Error occurred when trying to eject user");
    }
  }

  async function handleAcceptRequestToJoin(requestId) {
    console.log("Handle Accept Request", requestId);
    try {
      const { data } = await axios.post(
        `${API_LOCATION}/api/v1/meetingsession/${meetingSessionId}/meetingaccessrequests/${requestId}/approve?accessToken=${accessToken}`
      );
      console.log("Accept Request Success", data);

      let requests = meetingAccessRequests;
      for (let i = 0; i < requests.length; i++) {
        if (requests[i]._id.toString() === requestId.toString()) {
          requests.splice(i, 1);
        }
      }
      setMeetingAccessRequests([...requests]);
    } catch (ex) {
      console.log("Error occurred when trying to accept request", ex);
    }
  }

  const audioVideoSelector = (
    <AudioVideoSelector
      cameraMuted={cameraMuted}
      micMuted={micMuted}
      meeting={meeting}
      handleMicButtonClicked={handleMicButtonClicked}
      handleCameraButtonClicked={handleCameraButtonClicked}
      handleCameraChanged={handleCameraChanged}
      handleMicChanged={handleMicChanged}
      handleSpeakerChanged={handleSpeakerChanged}
      disableVideo={disableVideo}
      disableAudio={disableAudio}
    />
  );

  return (
    <div className="h-screen w-screen overflow-hidden flex flex-col">
      <Navbar
        appName={appName}
        roomName={roomName}
        DEADSIMPLESCREENSHARING_MODE={DEADSIMPLESCREENSHARING_MODE}
        ownBranding={ownBranding}
        brandName={brandName}
      />
      <div className="w-full h-full flex justify-center">
        <div className="max-w-screen-2xl w-full h-full">
          {!meetingJoined ? (
            <Join
              DEADSIMPLESCREENSHARING_MODE={DEADSIMPLESCREENSHARING_MODE}
              joining={joining}
              microphoneAccessBlocked={microphoneAccessBlocked}
              cameraAccessBlocked={cameraAccessBlocked}
              cameraMuted={cameraMuted}
              micMuted={micMuted}
              selectedCamera={selectedCamera}
              selectedMic={selectedMic}
              selectedSpeaker={selectedSpeaker}
              handleInputChanged={event => {
                setUsername(event.target.value);
              }}
              handleJoinMeetingBtnClick={handleJoinMeetingBtnClick}
              audioVideoSelector={audioVideoSelector}
            />
          ) : meetingLeft ? (
            <MeetingEnded meetingEndedMessage={defaultMeetingEndedMessage} />
          ) : (
            <CallLayout
              ownerOnlyBroadcast={window.ownerOnlyBroadcast}
              isAdmin={isAdmin}
              showInviteBox={showInviteBox}
              chatRoomURL={chatRoomURL}
              userInfo={userInfo}
              cameraMuted={cameraMuted}
              micMuted={micMuted}
              screenShared={screenShared}
              handRaised={handRaised}
              chatVisible={chatVisible}
              onlineUsersVisible={onlineUsersVisible}
              meeting={meeting}
              localMediaStream={localMediaStream}
              onlineUsers={onlineUsers}
              videoTiles={videoTiles}
              sidebarVisible={shouldSidebarBeVisible()}
              settingsVisible={settingsVisible}
              disableAudio={disableAudio}
              disableVideo={disableVideo}
              disableScreenSharing={disableScreenSharing}
              disabledChat={disabledChat}
              meetingAccessRequests={meetingAccessRequests}
              activeSpeakerId={activeSpeakerId}
              handleCameraButtonClicked={handleCameraButtonClicked}
              handleMicButtonClicked={handleMicButtonClicked}
              handleScreenShareButtonClicked={handleScreenShareButtonClicked}
              handleHandRaisedButtonClicked={handleHandRaisedButtonClicked}
              handleChatButtonClicked={handleChatButtonClicked}
              handleOnlineUsersButtonClicked={handleOnlineUsersButtonClicked}
              handleEndCallButtonClicked={handleEndCallButtonClicked}
              handleSettingsButtonClicked={handleSettingsButtonClicked}
              handleAcceptRequestToJoin={handleAcceptRequestToJoin}
              sidebarPosition="right"
              audioVideoSelector={audioVideoSelector}
              handleCameraChanged={handleCameraChanged}
              handleMicChanged={handleMicChanged}
              handleSpeakerChanged={handleSpeakerChanged}
              handleMuteUserAudio={handleMuteUserAudio}
              handleMuteUserVideo={handleMuteUserVideo}
              handleBanUser={handleBanUser}
              handleEjectUser={handleEjectUser}
            />
          )}
        </div>
      </div>
      <ToastContainer />
      {/* <Newsletter /> */}
      <ActiveSpeaker name={activeSpeakerName} />
    </div>
  );
}

export default App;
